export default __webpack_public_path__ + "static/media/9-small.a829fc65.png";